/**
 * Lead `postcode` is synced both ways with Dynamics (`byd_clientpostcode`). It must travel as a
 * string — a number drops leading zeros (`'0800'` Darwin -> `800`). Free text up to 100 chars,
 * because overseas buyers exist; the AU 4-digit format is only a soft hint, never a block.
 * See `docs/backend/leads/LEAD_POSTCODE_FRONTEND.md`.
 */
export const POSTCODE_MAX_LENGTH = 100;

/** Trimmed string for the API, or `null` when empty (clears the value). */
export function normalisePostcode(value: unknown): string | null {
  if (value === null || value === undefined) {
    return null;
  }
  const trimmed = String(value).trim();
  return trimmed ? trimmed : null;
}

/** True when there is a value and it isn't a 4-digit AU postcode — drives the soft hint. */
export function isNonAuPostcode(value: unknown): boolean {
  const postcode = normalisePostcode(value);
  return !!postcode && !/^\d{4}$/.test(postcode);
}
